import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import {
  PageHeaderComponent,
  PageHeaderContentRow1Right,
  PageHeaderContentRow2Left,
  PageHeaderContentRow2Right,
  PageHeaderContentRow3Left,
  PageHeaderContentRow3Right,
  PageHeaderTitleRow1Left,
} from './page-header.component';
@NgModule({
  imports: [
    CommonModule,
    PageHeaderComponent,
    PageHeaderTitleRow1Left,
    PageHeaderContentRow1Right,
    PageHeaderContentRow2Left,
    PageHeaderContentRow2Right,
    PageHeaderContentRow3Left,
    PageHeaderContentRow3Right,
  ],
  exports: [
    PageHeaderComponent,
    PageHeaderTitleRow1Left,
    PageHeaderContentRow1Right,
    PageHeaderContentRow2Left,
    PageHeaderContentRow2Right,
    PageHeaderContentRow3Left,
    PageHeaderContentRow3Right,
  ],
})
export class PageHeaderModule {}
